export default __webpack_public_path__ + "b4cf64e3f91fb2c0fb2bbdb563396428.svg";